import { render, staticRenderFns } from "./QuoteModal.vue?vue&type=template&id=118523cb&scoped=true"
import script from "./QuoteModal.vue?vue&type=script&lang=js"
export * from "./QuoteModal.vue?vue&type=script&lang=js"
import style0 from "./QuoteModal.vue?vue&type=style&index=0&id=118523cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118523cb",
  null
  
)

export default component.exports